import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const SettingRoute = [
    {
        path: '/settings',
        component: React.lazy(() => import('./Settings.js')),
        auth: AuthRoles.editor,
    }
]

export default SettingRoute;